(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reducedMotion.matches) return;

  const minimumDistance = 16;
  const minimumInterval = 34;
  const maximumPuffs = 22;
  let lastX = 0;
  let lastY = 0;
  let lastCreatedAt = 0;
  let activePuffs = 0;

  const createPuff = (x, y) => {
    if (activePuffs >= maximumPuffs) return;

    const puff = document.createElement('span');
    const size = 56 + Math.random() * 48;

    puff.className = 'ape-vapor-puff';
    puff.setAttribute('aria-hidden', 'true');
    puff.style.left = `${x}px`;
    puff.style.top = `${y}px`;
    puff.style.width = `${size}px`;
    puff.style.height = `${size}px`;
    puff.style.marginLeft = `${-size / 2}px`;
    puff.style.marginTop = `${-size / 2}px`;
    puff.style.setProperty('--ape-vapor-drift-x', `${(Math.random() - 0.5) * 52}px`);
    puff.style.setProperty('--ape-vapor-drift-y', `${-(38 + Math.random() * 44)}px`);
    puff.style.setProperty('--ape-vapor-scale', (1.45 + Math.random() * 0.85).toFixed(2));

    activePuffs += 1;
    document.body.appendChild(puff);
    puff.addEventListener('animationend', () => {
      puff.remove();
      activePuffs -= 1;
    }, { once: true });
  };

  window.addEventListener('mousemove', (event) => {
    const now = performance.now();
    const distance = Math.hypot(event.clientX - lastX, event.clientY - lastY);
    if (distance < minimumDistance || now - lastCreatedAt < minimumInterval) return;

    lastX = event.clientX;
    lastY = event.clientY;
    lastCreatedAt = now;
    createPuff(event.clientX, event.clientY);
  }, { passive: true });

  const routeContactLinks = () => {
    const root = window.Shopify?.routes?.root || '/';
    document.querySelectorAll('a').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'contact') {
        link.href = `${root}#ape-contact`;
      }
    });

    const productLink = document.querySelector('a[href*="/products/"]');
    const shopButton = document.querySelector('.apc-why .apc-btn');
    if (shopButton) {
      shopButton.href = productLink?.href || `${root}collections/all`;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', routeContactLinks, { once: true });
  } else {
    routeContactLinks();
  }
})();
